module.exports = __webpack_public_path__ + "img/approvalFailed2-icon.07d176bb.png";